function handleMenuCartClick() {
  try {
    const menuCart = document.querySelector('#menu-cart');
    if (menuCart) {
      menuCart.addEventListener('click', function() {
        document.body.classList.toggle('cart-open');

        if (document.body.classList.contains('menu-open')) {
          document.body.classList.remove('menu-open');
          const menuBtn = document.querySelector('.menu-btn');
          menuBtn.classList.remove('is-active');
          menuBtn.setAttribute('aria-expanded', 'false');

          const menuControls = menuBtn.getAttribute('aria-controls');
          const controlledElement = document.getElementById(menuControls);
          if (controlledElement) {
            controlledElement.setAttribute('aria-hidden', 'true');
          }
        }
      });
    }
  } catch (error) {
    console.error('An error occurred while handling the menu cart click:', error);
  }
}

handleMenuCartClick();


function openMenu() {
  const body = document.body;
  const menuBtn = document.querySelector('.menu-btn');
  const menuControls = menuBtn.getAttribute('aria-controls');
  const controlledElement = document.getElementById(menuControls);

  if (body.classList.contains('menu-open')) {
    body.classList.remove('menu-open');
    menuBtn.classList.remove('is-active');
    menuBtn.setAttribute('aria-expanded', 'false');
    if (controlledElement) {
      controlledElement.setAttribute('aria-hidden', 'true');
    }
  } else {
    body.classList.add('menu-open');
    menuBtn.classList.add('is-active');
    menuBtn.setAttribute('aria-expanded', 'true');
    if (controlledElement) {
      controlledElement.setAttribute('aria-hidden', 'false');
    }
    if (body.classList.contains('cart-open')) {
      body.classList.remove('cart-open');
      const closeButton = document.querySelector('button[data-action="close-drawer"]');
      if (closeButton) {
        closeButton.click();
      }
    }
  }
}

// Add event listener to the menu button if it exists
const menuBtn = document.querySelector('.menu-btn');
if (menuBtn) {
  menuBtn.addEventListener('click', openMenu);
}


// Handle keydown events
document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
        const body = document.body;
        if (body.classList.contains('menu-open')) {
            body.classList.remove('menu-open');
            const menuBtn = document.querySelector('.menu-btn');
            menuBtn.classList.remove('is-active');
            menuBtn.setAttribute('aria-expanded', 'false');

            const menuControls = menuBtn.getAttribute('aria-controls');
            const controlledElement = document.getElementById(menuControls);
            if (controlledElement) {
                controlledElement.setAttribute('aria-hidden', 'true');
            }
        }
    } else if (event.key === 'Enter' && event.target === menuBtn) {
        openMenu();
    }
});


function addSectionBreaks() {
    const navItems = document.querySelectorAll('.nav-list__item');

    navItems.forEach(item => {
        const link = item.querySelector('a');
        if (link && (link.href.includes('/account') || link.href.includes('/pages/our-saga'))) {
            const sectionBreak = document.createElement('li');
            sectionBreak.className = 'section-break';
            item.parentNode.insertBefore(sectionBreak, item);
        }
    });
}


function setHeaderHeight() {
    const headerContainer = document.querySelector('.header-container--wrapper');
    if (!headerContainer) return;
    const headerHeight = headerContainer.offsetHeight;
    document.body.style.setProperty('--header-height', `${headerHeight}px`);
}

function handleHover() {
    const parentItems = document.querySelectorAll('[data-img]');
    const navFigureImg = document.querySelector('.nav-figure img');
    const currentURL = window.location.href;
    const menuBtn = document.querySelector('.menu-btn');

    parentItems.forEach(item => {
        const dataImg = item.getAttribute('data-img');
        const itemURL = item.href;
        const subList = item.nextElementSibling;

        if (dataImg && navFigureImg && itemURL === currentURL) {
            menuBtn.addEventListener('click', () => {
                navFigureImg.style.opacity = 0;
                setTimeout(() => {
                    navFigureImg.src = dataImg;
                    navFigureImg.style.opacity = 1;
                }, 150);

                item.classList.add('is-active');
                item.closest(".nav-list__item").classList.add('is-active');
                item.closest(".nav-list__sub").setAttribute('aria-expanded', true);

                if (subList) {
                    subList.setAttribute('aria-expanded', 'true');
                }
            });

            item.classList.add('is-active');
            item.closest(".nav-list__item").classList.add('is-active');

            if (item.closest(".nav-list__sub")) {
                item.closest(".nav-list__sub").setAttribute('aria-expanded', true);

                if (subList) {
                    subList.setAttribute('aria-expanded', 'true');
                }
            }
        }
    });
}

function removeEmptyParagraphs() {
  const gridHeaders = document.querySelectorAll('.grid-header');
  if (!gridHeaders) return;

  gridHeaders.forEach((header) => {
    const paragraphs = header.querySelectorAll('p');

    paragraphs.forEach((paragraph) => {
      if (paragraph.textContent.trim() === '') {
        paragraph.remove();
      }
    });
  });
}


function hideDefaultTitles() {
    const spans = document.querySelectorAll('.product-meta__title p span');
    const regex = /default title/i;

    if (spans.length > 0) {
        spans.forEach(span => {
            if (regex.test(span.innerText)) {
                const parentParagraph = span.closest('.product-meta__title p');
                parentParagraph.remove();
            }
        });
    } else {}
}

function hideDefaultValue() {
    const spans = document.querySelectorAll('.sale-price span');

    if (spans.length > 0) {
        spans.forEach(span => {
            if (span.innerText.includes('value')) {
                span.innerText = span.innerText.replace('value ', '');
            }
        });
    }
}

function toggleSearch() {
    const searchElement = document.querySelector('#Search');
    const pageOverlayElement = document.querySelector('.PageOverlay');
    const bodyElement = document.querySelector('body');
    const recentList = document.querySelector('.Search--Recent ul');
    const suggestedList = document.querySelector('.Search--Suggested ul');
    const recentContainer = document.querySelector('.Search--Recent');
    const suggestedContainer = document.querySelector('.Search--Suggested');
    const searchResultsContainer = document.querySelector('.Search__Results');
    const menuButton = document.querySelector('.menu-btn');

    const isSearchHidden = searchElement.getAttribute('aria-hidden') === 'true';
    searchElement.setAttribute('aria-hidden', isSearchHidden ? 'false' : 'true');

    searchElement.tabIndex = isSearchHidden ? 0 : -1;

    bodyElement.classList.toggle('no-scroll');
    pageOverlayElement.classList.toggle('is-visible');

    const isRecentListEmpty = recentList && recentList.childElementCount === 0;
    const isSuggestedListEmpty = suggestedList && suggestedList.childElementCount === 0;

    recentContainer.style.display = isRecentListEmpty ? 'none' : 'block';
    suggestedContainer.style.display = isSuggestedListEmpty ? 'none' : 'block';

    searchResultsContainer.style.display = isRecentListEmpty && isSuggestedListEmpty ? 'none' : 'block';

    const isMenuOpen = bodyElement.classList.contains('menu-open');
    if (isMenuOpen) {
        bodyElement.classList.remove('menu-open');
        menuButton.classList.remove('is-active');
        menuButton.setAttribute('aria-expanded', 'false');
    }
}

try {
  const toggleSearchElements = document.querySelectorAll('[data-action="toggle-search"]');
  toggleSearchElements.forEach((element) => {
    element.addEventListener('click', toggleSearch);
  });

  const searchCloseElement = document.querySelector('.Search__Close');
  if (searchCloseElement) {
    searchCloseElement.addEventListener('click', toggleSearch);
  }
} catch (error) {
  console.error('An error occurred while setting up the search elements:', error);
}



document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        const searchElement = document.querySelector('#Search');
        if (searchElement.getAttribute('aria-hidden') === 'false') {
            toggleSearch();
        }
    }
});


const SiteNav = {
    init: function() {
        setHeaderHeight();
        window.addEventListener('resize', setHeaderHeight);

        let jsonData;
        
        const jsonDataElement = document.getElementById('json-data');
        if (jsonDataElement) {
          jsonData = JSON.parse(jsonDataElement.textContent);
        }

        let navList = document.querySelector('.nav-list');

        if (jsonData != undefined) {
          jsonData.forEach(item => {
            let listItem = document.createElement('li');
            listItem.className = 'nav-list__item';

            let link = document.createElement('a');
            if (item.url) {
              link.href = item.url;
            } else {
              link.setAttribute('role', 'button');
            }

            if (item.img) {
                try {
                    link.setAttribute("data-img", item.img);
                } catch (error) {
                    console.error('Error setting data-img attribute:', error);
                }
            } else if (item.children && item.children.length > 0 && item.children[0].img) {
                try {
                    link.setAttribute("data-img", item.children[0].img);
                } catch (error) {
                    console.error('Error setting data-img attribute from children:', error);
                }
            }

            link.className = 'nav-item';
            link.textContent = item.name;

            listItem.appendChild(link);

            if (item.children && item.children.length > 0) {
                listItem.classList.add('nav-list__parent');

                link.classList.add('nav-item__parent');
            }

            if (item.children && item.children.length > 0) {
                let subList = document.createElement('ul');
                subList.className = 'nav-list__sub';
                subList.setAttribute('aria-expanded', 'false');

                item.children.forEach(child => {
                    let childListItem = document.createElement('li');
                    let childLink = document.createElement('a');

                    if (child.img) {
                        try {
                            childLink.setAttribute("data-img", child.img);
                        } catch (error) {
                            console.error('Error setting data-img attribute for child:', error);
                        }
                    }

                    childLink.href = child.url;
                    childLink.className = 'nav-item nav-item__child';
                    childLink.textContent = child.name;

                    childListItem.appendChild(childLink);
                    subList.appendChild(childListItem);
                });

                listItem.appendChild(subList);
            }

            navList.appendChild(listItem);
        });
        }

        document.addEventListener('DOMContentLoaded', (event) => {
            const parentLinks = document.querySelectorAll('.nav-item__parent');

            if (parentLinks) {
                parentLinks.forEach(link => {
                    const parentItem = link.closest('.nav-list__parent');
                    const subList = parentItem.querySelector('.nav-list__sub');

                    if (link) {
                        link.addEventListener('click', e => {
                            const isActive = parentItem.classList.contains('is-active');

                            if (isActive) {
                                subList.setAttribute('aria-expanded', 'false');
                                parentItem.classList.remove('is-active');
                            } else {
                                const allParents = document.querySelectorAll('.nav-list__parent');
                                allParents.forEach(parent => {
                                    const sub = parent.querySelector('.nav-list__sub');
                                    if (parent !== parentItem) {
                                        sub.setAttribute('aria-expanded', 'false');
                                        parent.classList.remove('is-active');
                                    }
                                });

                                subList.setAttribute('aria-expanded', 'true');
                                parentItem.classList.add('is-active');
                            }
                        });
                    }
                });
            }

            handleHover();
        });

        addSectionBreaks();



        const newGridItems = document.querySelectorAll('.grid-item');
        if (newGridItems) {
            newGridItems.forEach(function(gridItem) {
                const featuredImage = gridItem.querySelector('.featured-image');
                const secondImage = gridItem.querySelector('.second-image');

                if (secondImage && featuredImage.offsetHeight < 700) {
                    gridItem.addEventListener('mouseover', function() {
                        featuredImage.classList.add('hidden');
                        secondImage.classList.add('visible');
                    });

                    gridItem.addEventListener('mouseout', function() {
                        featuredImage.classList.remove('hidden');
                        secondImage.classList.remove('visible');
                    });
                }
            });
        }

        hideDefaultTitles();
        hideDefaultValue();
        removeEmptyParagraphs();

    },
};

SiteNav.init();



function addStyleToLongParagraphs() {
  const gridHeaders = document.querySelectorAll('.grid-header');

  gridHeaders.forEach(gridHeader => {
    const nodes = gridHeader.getElementsByTagName('p');
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      const words = node.innerText.split(' ');

      if (words.length > 15) {
        node.style.textTransform = 'none';
      }
    }
  });
}

// addStyleToLongParagraphs();


// --------------------------------------------------
// Product Gallery
// --------------------------------------------------

function setThumbnailsMaxHeight() {
  try {
    const productWrapper = document.querySelector('.sproduct-wrapper');
    const thumbnailsContainer = document.querySelector('.sproduct-gallery--thumbnails');
    const screenWidth = window.innerWidth;

    if (productWrapper && thumbnailsContainer && screenWidth > 1024) {
      const productWrapperHeight = productWrapper.offsetHeight;
      thumbnailsContainer.style.maxHeight = productWrapperHeight + 'px';
    } else {
      thumbnailsContainer.style.maxHeight = ''; // Reset max-height if condition is not met
    }
  } catch (error) {
    console.error('An error occurred while setting thumbnails max height:', error);
  }
}

function initializeProductGallery() {
  const thumbnailsContainer = document.querySelector('.sproduct-gallery--thumbnails');
  const previewImage = document.querySelector('.sproduct-gallery--preview img');

  if (thumbnailsContainer && previewImage) {
    const thumbnails = thumbnailsContainer.querySelectorAll('a');

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent default link behavior

        const clickedThumbnail = event.target.querySelector('img');
        if (clickedThumbnail) {
          const thumbnailSrc = clickedThumbnail.getAttribute('src');
          const thumbnailAlt = clickedThumbnail.getAttribute('alt');

          previewImage.setAttribute('src', thumbnailSrc);
          previewImage.setAttribute('alt', thumbnailAlt);

          // Toggle the "is-active" class on the preview image
          previewImage.classList.toggle('is-active');
          previewImage.style.opacity = '0';
        }
      });
    });

    thumbnailsContainer.addEventListener('keydown', (event) => {
      const activeThumbnail = thumbnailsContainer.querySelector('[aria-current="true"]');
      const currentIndex = Array.from(thumbnails).indexOf(activeThumbnail);
      let nextIndex;

      if (event.code === 'ArrowLeft') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : thumbnails.length - 1;
      } else if (event.code === 'ArrowRight') {
        nextIndex = currentIndex < thumbnails.length - 1 ? currentIndex + 1 : 0;
      } else {
        return; // Exit early for non-arrow key presses
      }

      event.preventDefault(); // Prevent scrolling on arrow key press

      activeThumbnail.setAttribute('aria-current', 'false');
      thumbnails[nextIndex].setAttribute('aria-current', 'true');
      thumbnails[nextIndex].focus();

      const thumbnailSrc = thumbnails[nextIndex].getAttribute('src');
      const thumbnailAlt = thumbnails[nextIndex].getAttribute('alt');

      previewImage.setAttribute('src', thumbnailSrc);
      previewImage.setAttribute('alt', thumbnailAlt);

      // Toggle the "is-active" class on the preview image
      previewImage.classList.toggle('is-active');
      previewImage.style.opacity = '0';
    });

    // Set initial aria-current state on the first thumbnail
    const initialThumbnail = thumbnailsContainer.querySelector('a');
    if (initialThumbnail) {
      initialThumbnail.setAttribute('aria-current', 'true');

      // Programmatically click on the first thumbnail to display the first image
      initialThumbnail.click();
    }

    // Add "is-active" class 200ms after the image has loaded
    previewImage.addEventListener('load', () => {
      setTimeout(() => {
        previewImage.style.opacity = '1';
        previewImage.classList.add('is-active');
      }, 200);
    });
  } else {
    console.error('Failed to initialize product gallery. Thumbnails container or preview image not found.');
  }
}


// --------------------------------------------------
// Product Tabs
// --------------------------------------------------
function initializeProductTabs() {
  try {
    // Get the tab elements
    const tabHeaders = document.querySelectorAll('.sproduct-tab--header');
    const tabContentSections = document.querySelectorAll('.sproduct-tab--content');

    // Hide all tab contents except the first one
    tabContentSections.forEach((content, index) => {
      if (index !== 0) {
        content.style.display = 'none';
      }
    });

    // Add event listeners to each tab
    tabHeaders.forEach((tabHeader, index) => {
      tabHeader.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent default link behavior
			handleProductDescription();

        // Close other tabs
        tabHeaders.forEach((header, idx) => {
          if (idx !== index) {
            header.setAttribute('aria-selected', 'false');
            tabContentSections[idx].style.display = 'none';
          }
        });

        // Toggle the active state of the clicked tab
        const isActive = tabHeader.getAttribute('aria-selected') === 'true';
        tabHeader.setAttribute('aria-selected', !isActive);

        // Toggle the visibility of the corresponding tab content
        tabContentSections[index].style.display = isActive ? 'none' : 'block';
      });
    });
  } catch (error) {
    console.error('An error occurred while initializing product tabs:', error);
  }
}

// Call the function to initialize the product tabs
document.addEventListener('DOMContentLoaded', function() {
  initializeProductTabs();
});

const productDescription = document.querySelector('.sproduct-meta--description');
if (productDescription) {
  const descriptionText = productDescription.innerHTML.trim();
  const sentences = descriptionText.split('<br>').filter(sentence => sentence.trim() !== '');

  const wrappedSentences = sentences.map(sentence => `<p>${sentence}</p>`).join('');

  productDescription.innerHTML = wrappedSentences;
}


// --------------------------------------------------
// Read more
// --------------------------------------------------

function handleProductDescription() {
  try {
    const descriptionElement = document.querySelector('.sproduct-meta--description');

    if (descriptionElement) {
      const paragraphs = descriptionElement.querySelectorAll('p');

      if (paragraphs.length > 2) {
        const firstParagraph = paragraphs[0];
        const remainingParagraphs = Array.from(paragraphs).slice(1);

        // Check if the paragraph is already collapsed
        if (remainingParagraphs[0].style.display === 'none') {
          return; // Return early if already collapsed
        }

        remainingParagraphs.forEach((paragraph) => {
          paragraph.style.display = 'none';
        });

        const readMoreLink = document.createElement('a');
        readMoreLink.textContent = 'Read more';
        readMoreLink.addEventListener('click', () => {
          remainingParagraphs.forEach((paragraph) => {
            paragraph.style.display = 'block';
          });
          readMoreLink.parentNode.remove();
        });

        const readMoreParagraph = document.createElement('p');
        readMoreParagraph.appendChild(readMoreLink);

        descriptionElement.appendChild(readMoreParagraph);
      }
    }
  } catch (error) {
    console.error('An error occurred while handling the product description:', error);
  }
}
document.addEventListener('DOMContentLoaded', function() {
  handleProductDescription();
});


function updateProductVariant() {
  try {
    const variantsBtn = document.querySelector('#variants--btn');
    if (variantsBtn) {
      const variantText = variantsBtn.querySelector('span')?.textContent;
      const sproductVariant = document.querySelector('.sproduct-variant');
      if (sproductVariant) {
        sproductVariant.textContent = variantText;
      }
    }
  } catch (error) {
    console.error('An error occurred while updating product variant:', error);
  }
}
updateProductVariant();

function checkGalleryThumbnails() {
  const gallery = document.querySelector('.sproduct-gallery');
  if (!gallery) {
    return;
  }

  const thumbnails = gallery.querySelectorAll('.sproduct-gallery--thumbnails ul li');
  if (thumbnails.length <= 3) {
    return;
  }

    const windowWidth = window.innerWidth;
  if (windowWidth <= 1299) {
    return;
  }

  const productWrapper = document.querySelector('.sproduct-wrapper');
  const thumbnailsList = gallery.querySelector('.sproduct-gallery--thumbnails ul');

  const productWrapperHeight = productWrapper.offsetHeight;

  let totalThumbnailsHeight = 0;
  thumbnails.forEach((thumbnail) => {
    totalThumbnailsHeight += thumbnail.offsetHeight;
  });

  if (totalThumbnailsHeight > productWrapperHeight) {
    const slideDownArrow = document.createElement('div');
    slideDownArrow.className = 'slide-down-arrow';
    slideDownArrow.setAttribute('role', 'button');
    slideDownArrow.setAttribute('aria-expanded', 'false');
    slideDownArrow.setAttribute('aria-label', 'Expand thumbnails');
    slideDownArrow.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
        <path d="M 4.21875 10.78125 L 2.78125 12.21875 L 15.28125 24.71875 L 16 25.40625 L 16.71875 24.71875 L 29.21875 12.21875 L 27.78125 10.78125 L 16 22.5625 Z" fill="currentColor"/>
      </svg>
    `;
    thumbnailsList.insertAdjacentElement('afterend', slideDownArrow);

    const slideUpArrow = document.createElement('div');
    slideUpArrow.className = 'slide-up-arrow';
    slideUpArrow.setAttribute('role', 'button');
    slideUpArrow.setAttribute('aria-expanded', 'false');
    slideUpArrow.setAttribute('aria-label', 'Collapse thumbnails');
    slideUpArrow.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
        <path d="M 16 6.59375 L 15.28125 7.28125 L 2.78125 19.78125 L 4.21875 21.21875 L 16 9.4375 L 27.78125 21.21875 L 29.21875 19.78125 L 16.71875 7.28125 Z" fill="currentColor"/>
      </svg>
    `;
    thumbnailsList.insertAdjacentElement('beforebegin', slideUpArrow);

    function updateScrollArrows() {
      const maxScrollPosition = totalThumbnailsHeight - productWrapperHeight - 1;
      slideDownArrow.style.opacity = thumbnailsList.scrollTop >= maxScrollPosition ? 0 : 1;
      slideUpArrow.style.opacity = thumbnailsList.scrollTop === 0 ? 0 : 1;
    }

    slideDownArrow.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);

      if (!isExpanded) {
        const visibleThumbnails = Math.floor(productWrapperHeight / thumbnails[0].offsetHeight);
        const currentScrollPosition = thumbnailsList.scrollTop;
        const newScrollPosition = currentScrollPosition + thumbnails[0].offsetHeight;
        const maxScrollPosition = totalThumbnailsHeight - productWrapperHeight;

        if (newScrollPosition < maxScrollPosition) {
          thumbnailsList.scrollTo({ top: newScrollPosition, behavior: 'smooth' });
        } else {
          thumbnailsList.scrollTo({ top: maxScrollPosition, behavior: 'smooth' });
        }
      }
    });

   slideUpArrow.addEventListener('click', function() {
      const isExpanded = slideDownArrow.getAttribute('aria-expanded') === 'true';
      slideDownArrow.setAttribute('aria-expanded', !isExpanded);

      if (thumbnailsList.scrollTop > 0) {
        const currentScrollPosition = thumbnailsList.scrollTop;
        const newScrollPosition = currentScrollPosition - thumbnails[0].offsetHeight;

        if (newScrollPosition > 0) {
          thumbnailsList.scrollTo({ top: newScrollPosition, behavior: 'smooth' });
        } else {
          thumbnailsList.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    });

    thumbnailsList.addEventListener('scroll', updateScrollArrows);
    updateScrollArrows();

  }
}
function addPreviewArrows() {
  const preview = document.querySelector('.sproduct-gallery--preview');
  if (!preview) {
    return;
  }

  const windowWidth = window.innerWidth;
  if (windowWidth >= 1300) {
    return;
  }

  const thumbnails = document.querySelectorAll('.sproduct-gallery--thumbnails li');
  if (thumbnails.length <= 2) {
    return;
  }

  const leftArrow = document.createElement('div');
  leftArrow.className = 'preview-arrow left-arrow';
  leftArrow.innerHTML = '';
  preview.appendChild(leftArrow);

  const rightArrow = document.createElement('div');
  rightArrow.className = 'preview-arrow right-arrow';
  rightArrow.innerHTML = '';
  preview.appendChild(rightArrow);

  const paginationNav = document.querySelector('.sproduct-pagination'); // Get the dot pagination nav element
  const paginationLinks = paginationNav.querySelectorAll('a'); // Get the pagination links

  const currentThumbnail = document.querySelector('.sproduct-gallery--thumbnails li a[aria-current="true"]');
  let currentIndex = Array.from(thumbnails).indexOf(currentThumbnail.parentElement);

  leftArrow.addEventListener('click', function() {
    if (currentIndex === 0) {
      return;
    }

    currentIndex--;
    const prevThumbnail = thumbnails[currentIndex];
    prevThumbnail.querySelector('a').click();
    paginationLinks[currentIndex].click(); // Trigger click on corresponding pagination link
  });

  rightArrow.addEventListener('click', function() {
    if (currentIndex === thumbnails.length - 1) {
      return;
    }

    currentIndex++;
    const nextThumbnail = thumbnails[currentIndex];
    nextThumbnail.querySelector('a').click();
    paginationLinks[currentIndex].click(); // Trigger click on corresponding pagination link
  });

  let touchStartX = 0;
  let touchEndX = 0;

  preview.addEventListener('touchstart', function(event) {
    touchStartX = event.touches[0].clientX;
  });

  preview.addEventListener('touchend', function(event) {
    touchEndX = event.changedTouches[0].clientX;
    handleSwipeGesture();
  });

  function handleSwipeGesture() {
    const swipeThreshold = 50;
    const deltaX = touchEndX - touchStartX;

    if (deltaX > swipeThreshold) {
      // Swipe right
      if (currentIndex > 0) {
        currentIndex--;
        const prevThumbnail = thumbnails[currentIndex];
        prevThumbnail.querySelector('a').click();
        paginationLinks[currentIndex].click(); // Trigger click on corresponding pagination link
      }
    } else if (deltaX < -swipeThreshold) {
      // Swipe left
      if (currentIndex < thumbnails.length - 1) {
        currentIndex++;
        const nextThumbnail = thumbnails[currentIndex];
        nextThumbnail.querySelector('a').click();
        paginationLinks[currentIndex].click(); // Trigger click on corresponding pagination link
      }
    }
  }
}

function addDotPagination() {
  const preview = document.querySelector('.sproduct-gallery--preview');
  if (!preview) {
    return;
  }

  const windowWidth = window.innerWidth;
  if (windowWidth >= 1300) {
    return;
  }

  const thumbnails = document.querySelectorAll('.sproduct-gallery--thumbnails li');
  if (thumbnails.length <= 2) {
    return;
  }

  const paginationNav = document.createElement('nav');
  paginationNav.classList.add('sproduct-pagination'); // Add class 'sproduct-pagination' to the nav element

  const paginationLinks = [];

  thumbnails.forEach((_, index) => {
    const paginationLink = document.createElement('a');
   
    paginationLink.setAttribute('aria-label', `Go to slide ${index + 1}`);
    paginationLink.addEventListener('click', () => {
      handlePaginationClick(index);
      currentIndex = index; // Update currentIndex to match the clicked pagination index
    });

    paginationLinks.push(paginationLink);
    paginationNav.appendChild(paginationLink);
  });

  preview.appendChild(paginationNav);

  function handlePaginationClick(index) {
    thumbnails.forEach((thumbnail, i) => {
      const isActive = i === index;
      paginationLinks[i].classList.toggle('active', isActive);
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initializeProductGallery();
  setThumbnailsMaxHeight();
  window.addEventListener('resize', setThumbnailsMaxHeight);
  checkGalleryThumbnails();
  addDotPagination();
  addPreviewArrows();
});



